<template>
  <div class="div-box" style="padding:0 20px">
    <!-- v-loading="vloading" -->
    <div>
      <div class="div">
        <el-date-picker style="margin-right: 10px;" :clearable="false" v-model="queryParam.value"
          :format="nextWeekObj.showFlag ? nextWeekObj.year + '-' + nextWeekObj.month + ' 第1周' : 'yyyy-MM 第' + queryParam.week + '周'"
          @change="weekChange" value-format="yyyy-MM-dd" size="small" type="week" placeholder="请选择"
          :picker-options="{ 'firstDayOfWeek': 7 }"></el-date-picker>
        <div hidden>
          <el-date-picker size="small" v-model="reportTime" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </div>
        <el-select size="small" v-model="at.user" ref="slectUser" clearable placeholder="请选择用户" style="width:350px"
          @clear="clearUser" @visible-change="blur">
          <el-input size="mini" clearable v-if="treeData1.length != 0" placeholder="输入关键字进行过滤" v-model="filterText"
            style="width: 300px;margin: 0 20px">
          </el-input>
          <br>
          <el-option :label="at.user" :value="at.userkey" class="slectOption">
            <el-tree :data="treeData1" :default-expanded-keys="treeExpandData" ref="UserTree" node-key="key" show-checkbox
              @check="getChecked" :filter-node-method="filterNode">
              <span slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span v-if="data.mobile">({{ data.jobName }})</span>
              </span>
              <!-- <span class="custom-tree-node1" slot-scope="{ node, data }">
                    <span>{{ node.label }}</span>
                    <span v-if="data.mobile">
                      <input type="checkbox" :checked="currentMainKey.key === data.key" />
                    </span>
              </span>-->
            </el-tree>
          </el-option>
        </el-select>

        <el-button type="primary" size="small" icon="el-icon-search" @click="resetSearch">搜索</el-button>
      </div>
      <div class="div" style="float:right">
        <el-button @click="handleExportExcel" size="small" v-if="$_has('daily-report-export')">导出日报</el-button>
        <el-button type="primary" size="small" @click="daily()" icon="el-icon-plus">提交日报</el-button>
        <!-- <el-button type="primary" size="small" @click="weekly()" icon="el-icon-plus">提交周报</el-button> -->
      </div>
    </div>
    <div>
      <tableBody id="table" ref="table" :tableData="tableData" :tableNameList="tableColumns" :controller="tableController"
        :diyHeight="'calc(100vh - 200px)'" :rowStyle="{ height: '90px' }">
        <!-- <template v-for="(item,index) in weekNum" slot="item+''" slot-scope="list">
          <span :key="index"  >{{list.scope.row['item']}}</span>
        </template>-->
        <template slot="plan" slot-scope="list">
          <div class="floatLeft" v-if="list.scope.row['plan'][0].text === '未提交'" @click="daily">
            <u>{{ list.scope.row['plan'][0].text }}</u>
          </div>
          <el-popover placement="top" width="200" trigger="hover" :open-delay="2000" v-else>
            <span v-html="list.scope.row['plan'][0].employeeText">{{list.scope.row['plan'][0].text}}</span>
            <div slot="reference" v-html="list.scope.row['plan'][0].text" class="table-content">
              {{list.scope.row['plan'][0].text}}</div>
          </el-popover>
        </template>
        <template slot="0" slot-scope="list">
          <div :class="['floatLeft', { 'disabledText': list.scope.row['0'][0].employeeId !== currentUser.id}]"
            v-if="list.scope.row['0'][0].text === '未提交'" @click="dailyDate(list.scope.row['0'][0], 0)">
            <span v-if="list.scope.row['0'][0].employeeId !== currentUser.id">{{ list.scope.row['0'][0].text }}</span>
            <u v-else>{{ list.scope.row['0'][0].text }}</u>
          </div>
          <el-popover placement="top" width="200" trigger="hover" :open-delay="2000" v-else>
            <span v-html="list.scope.row['0'][0].employeeText" @click="getdailyInfo(list.scope.row['0'], 0)"
              class="cursor-pointer">{{list.scope.row['0'][0].text}}</span>
            <div slot="reference" v-html="list.scope.row['0'][0].text" @click="getdailyInfo(list.scope.row['0'], 0)"
              class="table-content">{{list.scope.row['0'][0].text}}</div>
          </el-popover>
          <div class="main-text" v-if="list.scope.row['0'][0].status === 2"></div>
          <span class="inner-text" v-if="list.scope.row['0'][0].status === 2">已退回</span>
        </template>
        <template slot="1" slot-scope="list">
          <div :class="['floatLeft', { 'disabledText': list.scope.row['0'][0].employeeId !== currentUser.id }]"
            v-if="list.scope.row['1'][0].text === '未提交'" @click="dailyDate(list.scope.row['1'][0], 1)">
            <span v-if="list.scope.row['1'][0].employeeId !== currentUser.id">{{ list.scope.row['1'][0].text }}</span>
            <u v-else>{{ list.scope.row['1'][0].text }}</u>
          </div>
          <el-popover placement="top" width="200" trigger="hover" :open-delay="2000" v-else>
            <span v-html="list.scope.row['1'][0].employeeText" @click="getdailyInfo(list.scope.row['1'], 1)"
              class="cursor-pointer">{{list.scope.row['1'][0].text}}</span>
            <div slot="reference" v-html="list.scope.row['1'][0].text" @click="getdailyInfo(list.scope.row['1'], 1)"
              class="table-content">{{list.scope.row['1'][0].text}}</div>
          </el-popover>
          <div class="main-text" v-if="list.scope.row['1'][0].status === 2"></div>
          <span class="inner-text" v-if="list.scope.row['1'][0].status === 2">已退回</span>
        </template>
        <template slot="2" slot-scope="list">
          <div :class="['floatLeft', { 'disabledText': list.scope.row['0'][0].employeeId !== currentUser.id }]"
            v-if="list.scope.row['2'][0].text === '未提交'" @click="dailyDate(list.scope.row['2'][0], 2)">
            <span v-if="list.scope.row['2'][0].employeeId !== currentUser.id">{{ list.scope.row['2'][0].text }}</span>
            <u v-else>{{ list.scope.row['2'][0].text }}</u>
          </div>
          <el-popover placement="top" width="200" trigger="hover" :open-delay="2000" v-else>
            <span v-html="list.scope.row['2'][0].employeeText" @click="getdailyInfo(list.scope.row['2'], 2)"
              class="cursor-pointer">{{list.scope.row['2'][0].text}}</span>
            <div slot="reference" v-html="list.scope.row['2'][0].text" @click="getdailyInfo(list.scope.row['2'], 2)"
              class="table-content">{{list.scope.row['2'][0].text}}</div>
          </el-popover>
          <div class="main-text" v-if="list.scope.row['2'][0].status === 2"></div>
          <span class="inner-text" v-if="list.scope.row['2'][0].status === 2">已退回</span>
        </template>
        <template slot="3" slot-scope="list">
          <div :class="['floatLeft', { 'disabledText': list.scope.row['0'][0].employeeId !== currentUser.id }]"
            v-if="list.scope.row['3'][0].text === '未提交'" @click="dailyDate(list.scope.row['3'][0], 3)">
            <span v-if="list.scope.row['3'][0].employeeId !== currentUser.id">{{ list.scope.row['3'][0].text }}</span>
            <u v-else>{{ list.scope.row['3'][0].text }}</u>
          </div>
          <el-popover placement="top" width="200" trigger="hover" :open-delay="2000" v-else>
            <span v-html="list.scope.row['3'][0].employeeText" @click="getdailyInfo(list.scope.row['3'], 3)"
              class="cursor-pointer">{{list.scope.row['3'][0].text}}</span>
            <div slot="reference" v-html="list.scope.row['3'][0].text" @click="getdailyInfo(list.scope.row['3'], 3)"
              class="table-content">{{list.scope.row['3'][0].text}}</div>
          </el-popover>
          <div class="main-text" v-if="list.scope.row['3'][0].status === 2"></div>
          <span class="inner-text" v-if="list.scope.row['3'][0].status === 2">已退回</span>
        </template>

        <template slot="4" slot-scope="list">
          <div :class="['floatLeft', { 'disabledText': list.scope.row['0'][0].employeeId !== currentUser.id }]"
            v-if="list.scope.row['4'][0].text === '未提交'" @click="dailyDate(list.scope.row['4'][0], 4)">
            <span v-if="list.scope.row['4'][0].employeeId !== currentUser.id">{{ list.scope.row['4'][0].text }}</span>
            <u v-else>{{ list.scope.row['4'][0].text }}</u>
          </div>
          <el-popover placement="top-end" width="200" trigger="hover" :open-delay="2000" v-else>
            <span v-html="list.scope.row['4'][0].employeeText" @click="getdailyInfo(list.scope.row['4'], 4)"
              class="cursor-pointer">{{list.scope.row['4'][0].text}}</span>
            <div slot="reference" v-html="list.scope.row['4'][0].text" @click="getdailyInfo(list.scope.row['4'], 4)"
              class="table-content">{{list.scope.row['4'][0].text}}</div>
          </el-popover>
          <div class="main-text" v-if="list.scope.row['4'][0].status === 2"></div>
          <span class="inner-text" v-if="list.scope.row['4'][0].status === 2">已退回</span>
        </template>

        <template slot="5" slot-scope="list">
          <div :class="['floatLeft', { 'disabledText': list.scope.row['0'][0].employeeId !== currentUser.id }]"
            v-if="list.scope.row['5'][0].text === '未提交'" @click="dailyDate(list.scope.row['5'][0], 5)">
            <span v-if="list.scope.row['5'][0].employeeId !== currentUser.id">{{ list.scope.row['5'][0].text }}</span>
            <u v-else>{{ list.scope.row['5'][0].text }}</u>
          </div>
          <el-popover placement="top" width="200" trigger="hover" :open-delay="2000" v-else>
            <span v-html="list.scope.row['5'][0].employeeText" @click="getdailyInfo(list.scope.row['5'], 5)"
              class="cursor-pointer">{{list.scope.row['5'][0].text}}</span>
            <div slot="reference" v-html="list.scope.row['5'][0].text" @click="getdailyInfo(list.scope.row['5'], 5)"
              class="table-content">{{list.scope.row['5'][0].text}}</div>
          </el-popover>
          <div class="main-text" v-if="list.scope.row['5'][0].status === 2"></div>
          <span class="inner-text" v-if="list.scope.row['5'][0].status === 2">已退回</span>
        </template>
        <template slot="6" slot-scope="list">
          <div :class="['floatLeft', { 'disabledText': list.scope.row['0'][0].employeeId !== currentUser.id }]"
            v-if="list.scope.row['6'][0].text === '未提交'" @click="dailyDate(list.scope.row['6'][0], 6)">
            <span v-if="list.scope.row['6'][0].employeeId !== currentUser.id">{{ list.scope.row['6'][0].text }}</span>
            <u v-else>{{ list.scope.row['6'][0].text }}</u>
          </div>
          <el-popover placement="top" width="200" trigger="hover" :open-delay="2000" v-else>
            <span v-html="list.scope.row['6'][0].employeeText" @click="getdailyInfo(list.scope.row['6'], 6)"
              class="cursor-pointer">{{list.scope.row['6'][0].text}}</span>
            <div slot="reference" v-html="list.scope.row['6'][0].text" @click="getdailyInfo(list.scope.row['6'], 6)"
              class="table-content">{{list.scope.row['6'][0].text}}</div>
          </el-popover>
          <div class="main-text" v-if="list.scope.row['6'][0].status === 2"></div>
          <span class="inner-text" v-if="list.scope.row['6'][0].status === 2">已退回</span>
        </template>
        <template slot="sumUp" slot-scope="list">
          <div :class="['floatLeft', { 'disabledText': list.scope.row['0'][0].employeeId !== currentUser.id }]"
            v-if="list.scope.row['sumUp'][0].text === '未提交'" @click="weeklyDate(list.scope.row['sumUp'][0])">
            <span v-if="list.scope.row['sumUp'][0].employeeId !== currentUser.id">{{ list.scope.row['sumUp'][0].text
            }}</span>
            <u v-else>{{ list.scope.row['sumUp'][0].text }}</u>
          </div>
          <el-popover placement="top" width="200" trigger="hover" :open-delay="2000" v-else>
            <span v-html="list.scope.row['sumUp'][0].employeeText" @click="getdailyInfo(list.scope.row['sumUp'], -1)"
              class="cursor-pointer">{{list.scope.row['sumUp'][0].text}}</span>
            <div slot="reference" v-html="list.scope.row['sumUp'][0].text"
              @click="getdailyInfo(list.scope.row['sumUp'], -1)" class="table-content">{{list.scope.row['sumUp'][0].text}}
            </div>
          </el-popover>
          <div class="main-text" v-if="list.scope.row['sumUp'][0].status === 2"></div>
          <span class="inner-text" v-if="list.scope.row['sumUp'][0].status === 2">已退回</span>
        </template>
      </tableBody>
      <pagination style="padding:0 10px;margin-top: 10px;" :pageSize="pagesize" :currentPage="currentPage"
        :pageTotal="pageTotal" @handleCurrentChange="handleCurrentChange"></pagination>
    </div>

    <dialog-panel :title="weekTitle" :dialogController="showBord" :width="'35%'" @cancel="showBord = false"
      :showCancel="false" :showConfirm="false">
      <div>
        <span class="text-size16px">
          <strong>【汇报内容】</strong>
        </span>
        <el-tag v-if="form.status === 2" type="danger" effect="dark" size="mini">已退回</el-tag>
      </div>
      <br />
      <div>提交时间：{{ form.createTime }}</div>
      <br />
      <span v-html="form.text" style="line-height:1.5">{{form.text}}</span>
      <br />
      <div v-if="form.status === 2">
        <el-divider></el-divider>
        <div>
          <span class="text-size16px">
            <strong>【退回原因】</strong>
          </span>
        </div>
        <br />
        <span v-html="form.returnReason" style="line-height:1.5"></span>
      </div>
      <br />
      <div class="dialogBottom">
        <el-button v-if="form.status === 2 && $_has('ro-back') && form.employeeId === currentUser.id" type="primary"
          size="small" @click="resubmit(form)" v-preventReClick>重新提交</el-button>
        <el-button v-else-if="canReturnBack" type="primary" size="small" @click="showReason(form)"
          v-preventReClick>退回重新</el-button>
        <el-button v-if="form.employeeId === currentUser.id" type="primary" size="small" @click="resubmit(form)"
          v-preventReClick>修改</el-button>
        <el-button v-if="form.employeeId === currentUser.id" type="danger" size="small" @click="deleteDaily(form)">删除</el-button>
      </div>
    </dialog-panel>
    <dialog-panel title="退回原因" :dialogController="showReasonBord" :width="'30%'" @cancel="showReasonBord = false"
      :showCancel="false" :showConfirm="false">
      <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 8 }" placeholder="请输入退回原因"
        v-model="at.returnReason"></el-input>
      <div class="dialogBottom">
        <el-button type="primary" size="small" @click="returnBack(at)" v-preventReClick>确定</el-button>
      </div>
    </dialog-panel>
  </div>
</template>

<script>
import * as api from "./reportAPI";
import { dateFormat, dateAddDay } from "utils/handle";
import { formatTreeAndPerson, getTreeAndPerson } from '../task-manage/taskAPI'
import { progressEstimatedelete } from '../project-manage/progress-estimate/api';
import {deleteDaily, exportDailyList} from "./reportAPI";
import XLSX from "xlsx";
import FileSaver from 'file-saver';
import {downloadsAPI} from "../project-manage/overtime-manage/report";

let week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
let weekShortDate = [] // 星期和日期
let weekDate = [] // 日期
let weekNum = ['0', '1', '2', '3', '4', '5', '6']
let weekday = 0 // 当天的星期
let nowDay = '' //当天日期

export default {
  data() {
    return {
      currentUser: JSON.parse(localStorage.getItem("currentUser")),
      canReturnBack: false,/**能重新回退 */
      form: {},
      tableData: [],
      tableColumns: [],
      tableController: {
        isActive: false,
        selection: false,
        index: false,
        width: 180,
        rowKey: '',
      },
      weekNum: ['0', '1', '2', '3', '4', '5', '6'],
      showBord: false,
      reportTime: [],
      showReasonBord: false,
      weekTitle: '周三(03.04)/\n提交<pre>单独</pre>时</br>间',
      at: {
        user: '',
        userkey: '',
      },
      queryParam: {
        value: '',
        week: ''
      },
      treeData1: [],
      pagesize: 10,
      currentPage: 1,
      pageTotal: 1,
      treeExpandData: [],
      nowDay: '', // 当天日期
      selectedDate: '', // 已选择日期
      // vloading: false,
      nextWeekObj: {
        year: '',
        month: '',
        showFlag: false
      },
      filterText: ''
    }
  },
  watch: {
    filterText(val) {
      this.$refs.UserTree.filter(val);
    }
  },
  methods: {
    handleExportExcel(){
      let data = {
        employeeId: this.currentUser.id,
        idList: this.at.userkey ? this.at.userkey : '',
        startReportTime: this.reportTime[0],
        endReportTime: this.reportTime[1],
        size: -1
      }
      exportDailyList(data).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '日报.xlsx');  // 设置文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })

    },
    exportExcel() {
      let tableDOMBackUp = document.querySelector('#table');
      // 克隆
      let tableDOM = tableDOMBackUp.cloneNode(true);
      let popoverParentList = tableDOM.querySelectorAll('.cell span div');
      console.log(tableDOMBackUp.querySelectorAll('.cell span div'))
      // 处理节点
      for (let i = 0; i < popoverParentList.length; i++) {
        // let popoverDOM = popoverParentList[i].querySelector('div');
        console.log(popoverParentList[i])
        let popoverDOM = popoverParentList[i].querySelector('.cursor-pointer');
        console.log(popoverDOM)
        // 删除掉popover，否则会有相同的一份数据
        if(popoverDOM){
          popoverParentList[i].removeChild(popoverDOM);
        }
      }

      console.log(tableDOM);

      // 1.生成Excel工作簿对象
      var wb = XLSX.utils.table_to_book(tableDOM);
      // // 2.手机号，身份证号等会默认使用科学计数法表示，则需要这样设置
      // var wb = XLSX.utils.table_to_book(tableDOM, { raw: true });
      // 获取二进制字符串作为输出
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        book: true,
        type: 'array',
      })
      try {
        let name = '日报.xlsx'
        FileSaver.saveAs(
          // Blob: 对象表示一个不可变 原始数据的类文件对象,不一定是JS原生格式的数据。
          // File: 基于Blob，继承了blob的功能并将其扩展使其支持用户系统上的文件。
          new Blob([wbout], { type: 'appliction/octet-stream' }),
          // 设置导出的文件名称可随意
          name
        )
      } catch (e) {
        if (typeof console != 'undefined') console.log(e, wbout);
      }
      // 返回一个新创建的Blob对象，其内容由参数中给定的数组串联组成。
      return wbout
    },
    deleteDaily(form){
      console.log(form)
      deleteDaily(form.id).then(res=>{
        this.search()
        this.showBord = false
      })
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 初始化日期
    getDay() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      this.nowDay = year + '-' + month + '-' + day;
      //判断是否已选择日期
      console.log('getDay方法selectedDate',this.selectedDate);
      if(this.selectedDate != 'undefined'  && this.selectedDate != null && this.selectedDate != ''){
        //已选择日期转为日期对象
        var selectedTime = new Date(this.selectedDate);
        console.log('selectedTime',new Date(this.selectedDate));
        var selectedYear = selectedTime.getFullYear();
        var selectedMonth = selectedTime.getMonth() + 1;
        var selectedDay = selectedTime.getDate();
        if (selectedMonth < 10) {
          selectedMonth = '0' + selectedMonth;
        }
        if (selectedDay < 10) {
          selectedDay = '0' + selectedDay;
        }
        //获取并赋值第几周
        this.queryParam.week = this.getWeekInMonth(new Date(this.selectedDate));
        //获取并赋值为年月日
        this.queryParam.value = selectedYear + '-' + selectedMonth + '-' + selectedDay;
      }else{
        //获取并赋值第几周
        this.queryParam.week = this.getWeekInMonth(new Date(this.nowDay));
        //获取并赋值为年月日
        this.queryParam.value = year + '-' + month + '-' + day;
      }
    },
    weekChange(val) {
      if (val) {
        // let arr = val.split('-');
        let nowDate = new Date()
        let changeData = new Date(val)
        let y = nowDate.getFullYear()
        let m = nowDate.getMonth()
        let cy = changeData.getFullYear()
        let cm = changeData.getMonth()
        this.queryParam.week = this.getWeekInMonth(new Date(val));
        if (cy === y && cm === m && this.queryParam.week === this.getWeekInMonth(nowDate)) { //切换的日期是同年同月同周,就选择当前的时间否则切换后填写日报的限制不正常
          val = nowDate
        }
        // console.log('周', val)
        this.funGetreportDate(val)
        this.currentPage = 1
        this.search()
      }
    },
    // 根据日期判断是月的第几周
    getWeekInMonth(t) {
      if (t == undefined || t == '' || t == null) {
        t = new Date();
      } else {
        var _t = new Date();
        _t.setYear(t.getFullYear());
        _t.setMonth(t.getMonth());
        _t.setDate(t.getDate());

        var date = _t.getDate(); //给定的日期是几号

        _t.setDate(1);
        var d = _t.getDay(); //1. 得到当前的1号是星期几。0-6
        var fisrtWeekend = d;
        console.log('data', date, d);
        if (d == 0) {
          fisrtWeekend = 1;
          //1号就是星期天
        } else {
          fisrtWeekend = 7 - d + 1; //第一周的周未是几号
        }
        if (date <= fisrtWeekend) {
          return 1;
        } else {
          if (fisrtWeekend == 1) {
            return Math.ceil((date + 1 - fisrtWeekend) / 7);
          } else {
            return 1 + Math.ceil((date + 1 - fisrtWeekend) / 7);
          }
        }
      }
    },
    //------------------
    showReason(data) {
      this.at = {
        data,
        ...this.at
      }
      this.showReasonBord = true
    },
    returnBack(data) {
      let dataPara = {
        id: data.id,
        returnReason: data.returnReason,
        returner: this.currentUser.id
      }
      if (data.type === 1) { //  日报
        api.returnBackDaily(dataPara).then(res => {
          if (res.code === 1000) {
            this.$message.success(`操作成功`)
            this.showReasonBord = false
            this.showBord = false
            this.search()
          }
        })
      } else { //  周报
        api.returnBackWeekly(dataPara).then(res => {
          if (res.code === 1000) {
            this.$message.success(`操作成功`)
            this.showReasonBord = false
            this.showBord = false
            this.search()
          }
        })
      }
    },
    getdailyInfo(row, index) {
      console.log(row, 'rwo')
      //将日期放到缓存
      localStorage.setItem(this.currentUser.id + 'selectedDate', weekDate[index]);
      this.form = row[0];
      console.log(row[0])
      if (index === -1) {
        this.weekTitle = '本周总结'
      } else {
        this.weekTitle = weekShortDate[index]
      }
      //判断能不能有回退日报周报的权限
      if (this.form.status !== 2 && this.$_has('ro-back') && this.form.employeeId !== this.currentUser.id) {
        api.hasReturnBackPermission(this.currentUser.id).then(res => {
          this.canReturnBack = res.data
          this.showBord = true
        })
      } else {
        this.showBord = true
      }
    },
    getMD(date) {
      let lstDate = date.split(' ')[0].split('-')
      let day = parseInt(lstDate[2])
      let month = lstDate[1]
      if (day < 10) {
        day = '0' + day
      }
      // if (month < 10) {
      //   month = '0' + month
      // }
      return '(' + month + '.' + day + ')'
    },
    selData(value) {
      if (value) {
        this.tableColumns = []
        weekShortDate = []
        weekDate = []
        let lstDate = value[0].split(' ')[0].split('-')
        let day = parseInt(lstDate[2]) + 1
        let month = lstDate[1]

        this.tableColumns.push({
          prop: 'employeeName',
          label: '姓名',
          width: 100
        }
          // , {
          //   prop: 'plan',
          //   label: '本周计划',
          //   align: 'left',
          // }
        )
        for (var i = 0; i < week.length; i++) {
          let strWeekDate = week[i] + this.getMD(dateAddDay(value[0], i))
          this.tableColumns.push({
            prop: i + "",
            label: strWeekDate,
            align: 'left'
          })
          weekShortDate.push(strWeekDate)
          weekDate.push(dateAddDay(value[0], i));
        }
        // this.tableColumns.push({
        //   prop: 'sumUp',
        //   label: '本周总结',
        //   align: 'left',
        // })
        let startDate = new Date(value[0]).getMonth() + 1
        let endDate = value[1]

      }
    },
    search() {
      // this.vloading = true
      if (this.reportTime) {
        this.selData(this.reportTime)

        // this.employeeIds = []
        // this.employeeIds = this.$refs.UserTree.getCheckedKeys()
        // if (this.employeeIds.length <= 0) {
        //   this.employeeIds.push(this.currentUser.id)
        // }
        // this.employeeIds.join(",")

        let para = {
          current: this.currentPage,
          employeeId: this.currentUser.id,
          idList: this.at.userkey ? this.at.userkey : '',
          startReportTime: this.reportTime[0],
          endReportTime: this.reportTime[1],
          size: this.pagesize
        }

        api.getWeeklyPage(para).then(res => {
          if (res.code === 1000) {
            this.tableData = api.getData(res.data.records)
            console.log('tableDatatableDatatableDatatableDatatableData', this.tableData)
            this.pageTotal = res.data.total
            // this.vloading = false
          }
        })
        this.$nextTick(() => {
          this.$refs.table.$children[0].bodyWrapper.scrollTop = 0
        })
      }
      // this.vloading = false
    },
    handleCurrentChange(v) {
      this.currentPage = v
      this.search()
    },
    resetSearch() {
      this.currentPage = 1
      this.search()
    },
    daily() {
      this.$router.push('/report-manage/daily')
      // this.$router.push({ path: '/report-manage/daily', query: { dailyId: id } })
    },
    dailyDate(obj, id) { // 未提交
      if (obj.employeeId === this.currentUser.id) {
        var oDate = new Date(this.nowDay); // 今天日期
        var oDate1 = new Date(this.reportTime[0]) // 开始日期
        var oDate2 = new Date(this.reportTime[1]); // 结束日期
        if ((oDate2 >= oDate && oDate >= oDate1 && id <= oDate.getDay()) // 本周 & 星期
          || (oDate2 <= oDate && oDate1 <= oDate)) { // 本周之前的日期
          //将日期放到缓存
          localStorage.setItem(this.currentUser.id + 'selectedDate', weekDate[id]);
          // 星期 不可提交今天之后的日报
          this.$router.push({ path: '/report-manage/daily', query: { reportTime: weekDate[id] } })
        } else {
          this.$message.warning(`不能填写今天之后的日报`)
        }
      }
    },
    weekly() {
      this.$router.push('/report-manage/weekly')
      // this.$router.push({        path: '/report-manage/weekly',
      //   query: { weeklyId: id }      })
    },
    weeklyDate(obj) { // 未提交
      if (obj.employeeId === this.currentUser.id) {
        this.$router.push({ path: '/report-manage/weekly', query: { startReportTime: this.reportTime[0], endReportTime: this.reportTime[1] } })
      }
    },
    resubmit(obj) { // 重新提交
      if (obj.type === 1) {
        this.$router.push({ path: '/report-manage/daily', query: { dailyId: obj.id } })
      } else {
        this.$router.push({
          path: '/report-manage/weekly',
          query: {
            weeklyId: obj.id, employeeId: obj.employeeId, lastWeeklyId: obj.lastWeeklyId,
            startReportTime: this.reportTime[0], endReportTime: this.reportTime[1]
          }
        })
      }
    },
    funGetreportDate(t) {
      let d = new Date
      if (t == undefined || t == '' || t == null) {
        // d = new Date();
      } else {
        d = new Date(t)
      }
      //周日设定的日期时间
      this.reportTime = []
      weekday = d.getDay() // 星期几
      d.setTime(d.getTime() - weekday * 24 * 60 * 60 * 1000); // 周日
      let year1, month1, day1;
      [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()]
      let date1 = new Date(year1, month1, day1, 7)
      this.reportTime.push(dateFormat(date1))
      //周六设定的日期时间
      let year2, month2, day2
      d.setTime(d.getTime() + (6) * 24 * 60 * 60 * 1000); // 周六
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()]
      let date2 = new Date(year2, month2, day2, 7)
      this.reportTime.push(dateFormat(date2))
      // this.reportTime.unshift(date2)
      if (month1 != month2) {
        this.nextWeekObj.showFlag = true
        this.nextWeekObj.year = d.getFullYear()
        this.nextWeekObj.month = (month2 + 1) > 9 ? month2 + 1 : '0' + (month2 + 1)
      } else if (day1 == 1 && day2 == 7) {
        this.nextWeekObj.showFlag = true
        this.nextWeekObj.year = d.getFullYear()
        this.nextWeekObj.month = (month2 + 1) > 9 ? month2 + 1 : '0' + (month2 + 1)
      } else this.nextWeekObj.showFlag = false
    },
    funGetTreeData() {
      getTreeAndPerson().then(res => { // 用户
        if (res.code === 1000) {
          this.treeData1 = formatTreeAndPerson(res.data)
          this.treeExpandData.push(this.treeData1[0].key)
        }
      })
    },
    getChecked(checkedNodes, checkedKeys) {
      // console.log('勾选选项下', checkedKeys.checkedNodes)
      let keyList = []
      let labelList = []
      let checkNodes = checkedKeys.checkedNodes
      checkNodes.forEach(item => {
        if (item.mobile) {
          keyList.push(item.key)
          labelList.push(item.label)
        }
      })
      this.at.userkey = keyList.join(';')
      this.at.user = labelList.join(';')
      this.currentPage = 1 // 选择人员是页码要还原
    },
    clearUser() {
      this.at.userkey = ''
      this.at.user = ''
      // this.at={}
      this.$refs.UserTree.setCheckedKeys([]);
      this.funGetTreeData()
    },
    blur(e) {
      if (e) {
        // this.$refs.UserTree.setCheckedKeys([]);
      }
    }
  },
  created() {
    //获取缓存中的日期
    this.selectedDate = localStorage.getItem(this.currentUser.id + 'selectedDate');
    this.getDay();
    console.log('created方法selectedDate',this.selectedDate);
    //判断是否存在已选择日期，如果无，默认用当前日期，反之用已选择时间
    if(this.selectedDate == 'undefined' || this.selectedDate == '' || this.selectedDate == null){
      this.funGetreportDate();
    }else{
      this.weekChange(this.selectedDate);
    }
    this.funGetTreeData() // 用户
  },
  mounted() {
    this.selData(this.reportTime)
    this.search()
  }
}
</script>
<style scoped>
#table >>> th .cell{
  text-align: center;
}
.div-box>>>.el-loading-spinner .circular {
  width: 2px;
  height: 2px;
  animation: loading-rotate 2s linear infinite;
  display: none;
}

.div-box>>>.el-loading-spinner {
  background: url(../../assets/loading.gif) no-repeat;
  background-size: 200px 200px;
  background-color: rgba(255, 255, 255);
  /* width: 50%;
  height: 50%; */
  width: 200px;
  height: 200px;
  position: relative;
  top: 40%;
  left: 45%;
}

.div {
  margin-top: 15px;
  margin-bottom: 15px;
  margin-right: 10px;
  letter-spacing: 10px;
  float: left;
}

.floatLeft {
  color: red;
  text-align: center;
  cursor: pointer;
}

.cur-poi{
  cursor: pointer;
}

.table-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 200px;
  line-height: 24px;
}

.cursor-pointer {
  line-height: 24px;
}

.slectOption {
  height: auto;
  overflow: auto;
  background-color: #fff;
}

.dialogBottom {
  margin-top: 20px;
  margin-bottom: 10px;
  text-align: center;
}

.disabledText {
  color: #ccc;
  cursor: default;
}

.main-text {
  position: absolute;
  top: -35px;
  left: -35px;
  border-bottom: 35px solid transparent;
  border-top: 35px solid transparent;
  border-left: 35px solid transparent;
  border-right: 35px solid red;
  overflow: hidden;
  transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  /* Internet Explorer */
  -moz-transform: rotate(45deg);
  /* Firefox */
  -webkit-transform: rotate(45deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(45deg);
  /* Opera */
}

.inner-text {
  color: #fff;
  position: absolute;
  top: 0;
  left: -1px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  /* Internet Explorer */
  -moz-transform: rotate(-45deg);
  /* Firefox */
  -webkit-transform: rotate(-45deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(-45deg);
  /* Opera */
  font-size: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/report-manage/list.vue